﻿import * as Models from '../../models/models';

export class AdminPaymentReceiptViewModel {
    requestId: string;
    reasonCode: string;
    decisionType: string;
    merchantReferenceCode: string;
}